import { useGet } from "utils/useFetch"
import { IInitiativesListing } from "../interface/department"
import { Checkbox, Spin } from "antd"
import { CustomSpin } from "components/custom/Loader"

interface props {
  keyResultId: number | null
  isAdmin?: boolean
}
const ViewInitiative = ({ keyResultId, isAdmin }: props) => {
  const { isLoading: isLoadingInitiativesListing, data: initiativesListing } =
    useGet<IInitiativesListing>({
      url: isAdmin
        ? `/api/v2/admin/okr/employee/keyresults/initiatives/${keyResultId}`
        : `/api/v2/employee/okr/initiatives/${keyResultId}`,
      instanceKey: "newArchAxiosInstance",
      enabled: !!keyResultId,
      onSuccess(data: any) {
        // setEmptyOKR(data.data.length === 0)
      },
    })

  return (
    <div className="flex flex-col gap-2 pl-6 mt-2 ">
      {isLoadingInitiativesListing ? (
        <div className="my-10 flex w-full justify-center items-center ">
          <CustomSpin spinning />
        </div>
      ) : initiativesListing?.data?.length ? (
        <>
          {initiativesListing?.data &&
            initiativesListing?.data?.map((item, idx) => (
              <div
                className="py-2.5 px-[7px] shadow-sm  bg-white  rounded-md flex items-center justify-between "
                key={idx}
              >
                <div className="flex items-center gap-2">
                  <Checkbox
                    style={{
                      fontSize: "20px",
                    }}
                    className="round-checkbox"
                  />
                  <p className="text-[#42526D] font-medium text-sm ">
                    {item.initiativeName}
                  </p>
                </div>
                {/* <Dropdown
                  menu={{
                    items: [
                      {
                        key: "details",
                        label: (
                          <button className="font-circular !text-neutral400 w-full text-left">
                            View Details
                          </button>
                        ),
                      },
                    ],
                  }}
                >
                  <button>
                    <EllipsisHorizontalIcon className="w-6 h-6 text-primary500" />
                  </button>
                </Dropdown> */}
              </div>
            ))}
        </>
      ) : (
        <div className="my-10 flex w-full justify-center items-center ">
          No Initiatives Found
        </div>
      )}
    </div>
  )
}

export default ViewInitiative
